import { AreYouSureDialog } from './are-you-sure-dialog.class';

export class DefaultAreYouSureDialog extends AreYouSureDialog {
  confirm(message: string) {
    return window.confirm(message);
  }
}
